import { ref, h } from 'vue'
import { localCache } from './cache'
import { Modal as AModal, Checkbox as ACheckbox } from 'ant-design-vue'

//检查浏览器版本Chrome <87、Firefox <78、Safari <14、Edge <88 或 IE11 及更低版本
export function checkBrowser() {
  let result = true
  const ua = navigator.userAgent
  const isIE = /MSIE|Trident/.test(ua)
  const isEdgeLegacy = /Edg\//.test(ua) && parseInt(RegExp.$1) < 88 // Edge <88 的旧版本
  const isChromeOld = /Chrome\/(\d+)/.test(ua) && parseInt(RegExp.$1) < 87
  const isFirefoxOld = /Firefox\/(\d+)/.test(ua) && parseInt(RegExp.$1) < 78
  const isSafariOld = /Version\/(\d+).+Safari/.test(ua) && parseInt(RegExp.$1) < 14

  if (isIE || isEdgeLegacy || isChromeOld || isFirefoxOld || isSafariOld) {
    result = false
  }

  return result
}

//pro专业版，common普通版
export function getVersionType() {
  const versionType = sessionStorage.getItem('versionType') || null
  return versionType
}

export function setVersionType(value) {
  sessionStorage.setItem('versionType', value)
}

export function checkLogin() {
  return localCache.getCache('USER') && localCache.getCache('TOKEN')
}

let modalClosedTime = 0
export function confirmModal(valueStates) {
  // 关闭后 1 秒内不校验
  const currentTime = Date.now()
  if (currentTime - modalClosedTime < 1000) {
    return Promise.resolve(true)
  }

  const { initText, newText } = valueStates
  let agree = ref(false)
  return new Promise((resolve) => {
    if (
      initText?.length > 0 &&
      newText?.length > 0 &&
      initText !== newText &&
      !localCache.getCache('agreeAgentInputChange')
    ) {
      AModal.confirm({
        title: '温馨提示',
        centered: true,
        content: h('div', {}, [
          h('p', '识别到您已输入提示词，切换智能体后，已输入的提示词将会清空，是否确认切换？'),
          h(
            ACheckbox,
            {
              class: 'mt-6',
              checked: agree,
              'onUpdate:checked': (val) => {
                agree.value = val
              }
            },
            '知道了，不再提示'
          )
        ]),
        onOk() {
          modalClosedTime = Date.now()
          if (agree.value) localCache.setCache('agreeAgentInputChange', true)
          resolve(true)
        },
        onCancel() {
          modalClosedTime = Date.now()
          resolve(false)
        }
      })
    } else {
      modalClosedTime = Date.now()
      resolve(true)
    }
  })
}
